import { isSocialPostingProgram, renderProgramSummaryValue } from '../../util';
import { ResolvedProgramDatesField, ResolvedProgramSummary } from '../../types';
import {
  SOCIAL_MEDIA_ASSET_DIRECT_INSTAGRAM_ACCOUNT,
  SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE,
  SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT,
  SOCIAL_MEDIA_ASSET_YOUTUBE_CHANNEL,
  SocialMediaAssetType,
} from '../../../social-posting/socialPostingApi';
import facebookLogo from '../../../assets/images/facebook.png';
import instagramLogo from '../../../assets/images/instagram.png';
import youTubeLogo from '../../../assets/images/youtube-icon-square.png';
import clsx from 'clsx';
import { getAggregatePostStatus } from '../social-posting/utils';
import moment from 'moment';
import { CalendarViewType, UnscheduledViewType } from '../../containers/types';
import { nonBreakableSpace } from '../../../util/utils';

const SocialMediaAsset = (props: {
  program: ResolvedProgramSummary;
  type: SocialMediaAssetType;
  alternativeType?: SocialMediaAssetType;
}) => {
  const { program, type, alternativeType } = props;
  const socialMedia = program.socialMedia;
  if (!socialMedia) return null;
  const postsOfType = socialMedia.posts.filter(
    (x) => x.type === type || x.type === alternativeType
  );
  const publishOn = program.startDateTime;
  const content = socialMedia.content;
  const aggregateStatus = getAggregatePostStatus(content, publishOn, postsOfType).status;
  return (
    <div
      className={clsx('calendar__program-event-social-asset-icon-wrapper', {
        'calendar__program-event-social-asset-icon-wrapper--error': aggregateStatus === 'ERROR',
        'calendar__program-event-social-asset-icon-wrapper--published':
          aggregateStatus === 'SUCCESS',
        'calendar__program-event-social-asset-icon-wrapper--pending': aggregateStatus === 'PENDING',
        'calendar__program-event-social-asset-icon-wrapper--unscheduled':
          aggregateStatus === 'UNSCHEDULED',
      })}
    >
      <img
        src={
          type === SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE
            ? facebookLogo
            : type === SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT
            ? instagramLogo
            : type === SOCIAL_MEDIA_ASSET_YOUTUBE_CHANNEL
            ? youTubeLogo
            : undefined
        }
        alt={
          type === SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE
            ? 'Facebook'
            : type === SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT
            ? 'Instagram'
            : type === SOCIAL_MEDIA_ASSET_YOUTUBE_CHANNEL
            ? 'YouTube'
            : ''
        }
        className={clsx('calendar__program-event-social-asset-icon', {
          'calendar__program-event-social-asset-icon--unselected': postsOfType.length === 0,
        })}
      />
    </div>
  );
};

export const CalendarExtraFields = (props: {
  program: ResolvedProgramSummary;
  visibleColumns: string[];
  shortcutFieldNamesOnly: boolean;
  viewType: CalendarViewType | typeof UnscheduledViewType;
}) => {
  const { program, visibleColumns, shortcutFieldNamesOnly, viewType } = props;
  const isSocialPosting = isSocialPostingProgram(program);
  return (
    <div
      className={clsx('calendar__program-fields-wrapper', {
        'calendar__program-fields-wrapper--social-posting': isSocialPosting,
      })}
    >
      {visibleColumns.map((col) =>
        !isSocialPosting || col === ResolvedProgramDatesField ? (
          <div
            key={col}
            className="calendar__program-event-column text--truncated"
            data-test={`calendar__program-event-column-${col}`}
          >
            {renderProgramSummaryValue(program, col, shortcutFieldNamesOnly)}
          </div>
        ) : (
          <></>
        )
      )}
      {program.socialMedia && (
        <>
          <SocialMediaAsset program={program} type={SOCIAL_MEDIA_ASSET_FACEBOOK_PAGE} />
          <SocialMediaAsset
            program={program}
            type={SOCIAL_MEDIA_ASSET_INSTAGRAM_ACCOUNT}
            alternativeType={SOCIAL_MEDIA_ASSET_DIRECT_INSTAGRAM_ACCOUNT}
          />
          <SocialMediaAsset program={program} type={SOCIAL_MEDIA_ASSET_YOUTUBE_CHANNEL} />
          {viewType === UnscheduledViewType ||
          program.startDateTime < moment().subtract(24, 'hours').toDate()
            ? null
            : viewType === 'monthGridQuarter'
            ? `Publishes ${moment(program.startDateTime).format('MMM D')} at ${moment(
                program.startDateTime
              ).format('h:mm A')}`
            : viewType === 'dayGridMonth'
            ? `Publishes at ${moment(program.startDateTime).format(`h:mm${nonBreakableSpace}A`)}`
            : null}
        </>
      )}
    </div>
  );
};
